module.exports = __webpack_public_path__ + "img/amazonas.2815da14.png";